/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { SsotokenService } from "../ssotoken/ssotoken.service";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private SsotokenService: SsotokenService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (environment.production) {
      headersConfig["apikey"] = "he1vlKPJCXFyi0ZNfOkvvl31r0cGAoYO";
    } else {
      headersConfig["apikey"] = "fuQJVJ9jrOcZZVkefo43I5w44iD3JU5H";
    }

    headersConfig["Strict-Transport-Security"] = "max-age=31536000";
    if (this.SsotokenService.getSSOToken()) {
      headersConfig["PearsonSSOSession"] = this.SsotokenService.getSSOToken();
    }
    const request = req.clone({ setHeaders: headersConfig });

    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "";
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        // window.alert(errorMessage);
        return throwError(errorMessage);
      })
    );
  }
}
